import { memo, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { ChevronDown } from 'lucide-react';
import settings from '@/settings';
import {
  getCurrentCountry,
  mapLocaleToLanguage,
} from '../../Navbar/ExtendedNavbar/TopNavbar/StoreSelector/constants';
import LangCountrySelectorModal from './LangCountrySelectorModal';

const LangCountrySelector = memo(() => {
  const [openCountryPopup, setCountryPopup] = useState(false);
  const router = useRouter();
  const selectedStore = getCurrentCountry(settings.store);
  const language = mapLocaleToLanguage(
    (router.locale || 'en') as 'fr' | 'de' | 'es' | 'en',
  );

  if (selectedStore == null) {
    return null;
  }

  return (
    <>
      <div
        onClick={() => setCountryPopup(true)}
        className="relative flex w-full cursor-pointer items-center rounded bg-white/10 px-3 py-2 sm:w-auto"
      >
        <span className="flex h-6 w-6 shrink-0 items-center">
          <Image
            src={selectedStore.flag}
            alt={selectedStore.country}
            width={24}
            height={24}
            sizes="24px"
            loading="lazy"
            className="h-full w-full object-contain"
          />
        </span>
        <span className="ml-3 min-w-[130px] border-l-2 border-gray-700 pl-4 text-xs leading-6">
          {language}
        </span>
        <span className="absolute right-3 top-2/4 inline-flex -translate-y-2/4 items-center justify-center">
          <ChevronDown className="h-4 w-4" />
        </span>
      </div>
      <LangCountrySelectorModal
        isOpen={openCountryPopup}
        onClose={() => setCountryPopup(false)}
      />
    </>
  );
});

export default LangCountrySelector;
